import { FETCH_USERS } from "redux/constants/flowDesigner";

export const fetchUsers = (tenant_id) => ({
  type: FETCH_USERS,
  payload: { tenant_id }
});
